'use client'

import { FunctionComponent, useEffect } from 'react'
import { createGtmProduct, gtmPush, waitForPageView } from '../../utils/gtmHelpers'

type ProductGtmEventProps = {
  product: Product
}
const ProductGtmEvent: FunctionComponent<ProductGtmEventProps> = ({ product }) => {
  useEffect(() => {
    const abortSignal = { value: false };
    (async () => {
      await waitForPageView('Fiche Article', abortSignal);
      if (abortSignal.value) {
        return;
      }
      gtmPush({
        event: product.stock_status === "IN_STOCK" ? 'view_item' : 'view_unavailable_item',
        ecommerce: {
          currency: product?.price_range?.minimum_price?.regular_price?.currency,
          value: product?.price_range?.minimum_price?.regular_price.value,
          items: [createGtmProduct(product)],
        },
      })
    })()
    
    return () => {
      abortSignal.value = true;
    }
  }, [])

  return null
}

export default ProductGtmEvent
